import { initializeApp } from 'firebase/app';
import { getAnalytics, setUserProperties } from 'firebase/analytics';

import { getFirestore } from 'firebase/firestore';
import { getAuth, User } from 'firebase/auth';
import { useAuthState as useAuthStateFirebase } from 'react-firebase-hooks/auth';

import { getStorage } from "firebase/storage";

const app = initializeApp({
    apiKey: 'AIzaSyDDiTtZ9pbLl6yCvtotQBm26sBEwYmqrbQ',
    authDomain: 'swiftdocs-439bf.firebaseapp.com',
    projectId: 'swiftdocs-439bf',
    storageBucket: 'swiftdocs-439bf.appspot.com',
    messagingSenderId: '200906367476',
    appId: '1:200906367476:web:88ce82eac65de536f259a1',
    measurementId: 'G-XP8325BJB2',
});

export const auth = getAuth();
export const storage = getStorage();
export const downloadUrls = new Map<string, string>()

export const analytics = getAnalytics(app);
export const db = getFirestore(app);

const tenants: { [key: string]: boolean } = {};

export const getTenant = (email: string | null | undefined): string => {
    if (!email) {
        return '';
    }
    const segments = email.split('@');
    if (segments.length < 1) {
        return '';
    }
    const tenant = segments[segments.length - 1].replaceAll('.', '_');
    if (!tenants[tenant]) {
        tenants[tenant] = true;
        setUserProperties(analytics, { tenant });
    }
    return tenant === 'terminos_io'
        ? localStorage.getItem('impersonatedTenant') || 'terminos_io'
        : tenant;
};

export const useAuthState = (): [User | null | undefined, boolean, string] => {
    const [user, pending] = useAuthStateFirebase(auth);
    const tenant = getTenant(user?.email);
    return [user, pending, tenant];
};
